const cardStyles = {
  height: '100%'
}
const imageStyles = { width: '60px', height: '60px' }

export { cardStyles, imageStyles }
